import { IconButton, SxProps, TextField, Theme } from '@mui/material';
import { t } from 'i18next';
import UpdatePasswordForm from '../organisms/password-forms/UpdatePasswordForm';
import { useModal } from '../../hooks/useDialog';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import { mergeSx } from '../../utils/styles';

import type { JSX } from 'react';

const styles = {
  input: {
    '& .MuiOutlinedInput-root.Mui-disabled': {
      backgroundColor: 'transparent',
    },
    '& .Mui-disabled': {
      borderColor: 'neutral.300',
      color: 'text.primary',
    },
    '& .MuiInputLabel-root.Mui-disabled': {
      color: 'text.primary',
      borderColor: 'white',
    },
    '& .MuiInputBase-root.MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
      borderColor: 'neutral.300',
    },
  },
};

const PasswordField = ({
  shouldVerifyEmail,
  handleEmailVerification,
  sx,
}: {
  shouldVerifyEmail?: boolean;
  handleEmailVerification?: () => JSX.Element;
  sx?: SxProps<Theme>;
}) => {
  const emailVerification = shouldVerifyEmail && !!handleEmailVerification;
  const { openModal } = useModal();
  return (
    <TextField
      name='password'
      label={t('password')}
      value={'********'}
      disabled
      sx={mergeSx(styles.input, sx)}
      slotProps={{
        input: {
          sx: { pr: 0.5 },
          endAdornment: (
            <IconButton
              onClick={() =>
                openModal(emailVerification ? handleEmailVerification() : <UpdatePasswordForm />, {
                  slotProps: {
                    paper: {
                      sx: { backgroundColor: 'background.paper', borderRadius: 3, width: '100%', margin: 0 },
                    },
                  },
                })
              }
            >
              <EditNoteOutlinedIcon color='primary' />
            </IconButton>
          ),
        },
      }}
    />
  );
};

export default PasswordField;
